import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ProductionPlanActualReport.css";

import config from "../../config/config";
import { getAuthToken } from "../../utils/token";

const ProductionPlanActualReport = () => {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    //set current date
    const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

    const handlePrint = () => {
        window.print();
    };

    const fetchReport = async () => {
        const token = getAuthToken();

        if (!token) {
            setError("JWT token not found.");
            setReport(null);
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError("");

            const response = await axios.post(
                `${config.API}/senmanager/productionplanactual`,
                {
                    date: date,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            const result = response?.data;

            console.log(
                "Production Report Response:",
                result
            );

            if (result?.success) {
                setReport(result.data);
                setError("");
            } else {
                setReport(null);
                setError(
                    result?.message ||
                    "Unable to load production report."
                );
            }
        } catch (err) {
            console.error(
                "Production Report Error:",
                err?.response?.data || err
            );

            setReport(null);

            setError(
                err?.response?.data?.message ||
                "Something went wrong while loading the report."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport();
    }, [date]);

    const handleDateChange = (e) => {
        setDate(e.target.value);
        setError("");
    };

    const handleReset = () => {
        setError("");
        setReport(null);
        setDate("2026-08-14");
    };
const totalActualMan = (report?.production || []).reduce(
    (total, item) =>
        total + Number(item?.actual_utilized_man || 0),
    0
);
    return (
        <div className="production-report-screen">

            {/* =================================
                TOP TOOLBAR
            ================================= */}

            <div className="production-report-toolbar">

                <div className="production-report-toolbar-content">

                    <div className="production-report-toolbar-title">

                        <div className="production-report-title-icon">
                            <span>▦</span>
                        </div>

                        <div>
                            <h3>
                                Production Plan Vs Actual
                            </h3>

                            <p>
                                Production performance report
                            </p>
                        </div>

                    </div>

                    <div className="production-report-toolbar-actions">

                        <div className="production-report-date">

                            <span className="date-icon">
                                ▣
                            </span>

                            <input
                                type="date"
                                value={date}
                                onChange={handleDateChange}
                            />

                        </div>

                        <button
                            type="button"
                            onClick={fetchReport}
                            className="report-refresh-btn"
                            disabled={loading}
                        >
                            <span>
                                {loading ? "⟳" : "↻"}
                            </span>

                            {loading
                                ? "Loading..."
                                : "Refresh"}
                        </button>

                        <button
                            type="button"
                            onClick={handlePrint}
                            className="print-report-btn"
                            disabled={!report || loading}
                        >
                            <span>⇩</span>
                            Print / PDF
                        </button>

                    </div>

                </div>

            </div>


            {/* =================================
                REPORT CONTENT
            ================================= */}

            {loading ? (

                /* LOADING */
                <div className="production-report-wrapper">

                    <div className="production-report-loading">

                        <div className="production-report-spinner"></div>

                        <div>
                            Loading Production Report...
                        </div>

                    </div>

                </div>

            ) : error ? (

                /* ERROR */
                <div className="production-report-wrapper">

                    <div className="production-report">

                        <div
                            className="production-report-error"
                            style={{
                                minHeight: "220px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                padding: "30px",
                            }}
                        >

                            <div
                                className="text-danger mb-3"
                                style={{
                                    fontSize: "34px",
                                }}
                            >
                                <i className="bi bi-exclamation-triangle-fill"></i>
                            </div>

                            <h5 className="fw-semibold mb-2">
                                Unable to Load Report
                            </h5>

                            <p className="text-muted small mb-3">
                                {error}
                            </p>

                            <div className="d-flex justify-content-center gap-2">

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm px-3"
                                    onClick={fetchReport}
                                >
                                    <i className="bi bi-arrow-clockwise me-1"></i>
                                    Try Again
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm px-3"
                                    onClick={handleReset}
                                >
                                    <i className="bi bi-arrow-counterclockwise me-1"></i>
                                    Reset
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            ) : !report ? (

                /* NO DATA */
                <div className="production-report-wrapper">

                    <div className="production-report">

                        <div
                            className="production-report-error"
                            style={{
                                minHeight: "220px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                            }}
                        >
                            No report data available.
                        </div>

                    </div>

                </div>

            ) : (

                /* =================================
                   ACTUAL REPORT
                ================================= */

                <div className="production-report-wrapper">

                    <div className="production-report">

                        <table className="production-table">

                            <colgroup>
                                <col className="col-item" />
                                <col className="col-machine" />
                                <col className="col-manpower" />
                                <col className="col-utilized" />
                                <col className="col-target" />
                                <col className="col-actual" />
                                <col className="col-remark" />
                            </colgroup>

                            <thead>

                                <tr className="company-row">
                                    <th colSpan="7">
                                        {report.company?.name}
                                    </th>
                                </tr>

                                <tr className="report-title-row">

                                    <th colSpan="6">
                                        {report.report?.title}
                                    </th>

                                    <th className="report-date">
                                        {report.report?.display_date}
                                    </th>

                                </tr>

                                <tr className="column-header">

                                    <th>
                                        MACHINE
                                        <br />
                                        NO.
                                    </th>

                                    <th>
                                        ITEM
                                    </th>

                                    <th>
                                        MAN POWER
                                        <br />
                                        REQUIRED
                                    </th>

                                    <th>
                                        ACTUAL
                                        <br />
                                        UTILIZED
                                        <br />
                                        MAN
                                    </th>

                                    <th>
                                        PRODUCTION TARGET(12 HOURS)
                                    </th>
                                    <th className="actual-production-header">
                                        ACTUAL
                                        <br />
                                        PRODUCTION
                                    </th>

                                    <th>
                                        REMARK
                                    </th>
                                </tr>

                            </thead>

                            <tbody>

                                {/* =================================
                                    PRODUCTION
                                ================================= */}

                                {report.production?.map(
                                    (item, index) => (
                                        <tr
                                            key={`production-${index}`}
                                        >

                                            <td className="center">
                                                {item.machine_no || ""}
                                            </td>

                                            <td>
                                                {item.item}
                                            </td>

                                            <td className="center">
                                                {item.man_power_required}
                                            </td>

                                            <td className="center">
                                                {item.actual_utilized_man}
                                            </td>

                                            <td className="center bold">

                                                {(Number(
                                                    item.max_cycles || 0
                                                ) *
                                                    Number(
                                                        String(
                                                            item.die_type ||
                                                            "0"
                                                        ).replace(
                                                            /[^0-9.]/g,
                                                            ""
                                                        )
                                                    ) / 2)}
                                            </td>

                                            <td className="center bold">

                                                {item.actual_production
                                                    ?.quantity ?? 0}{" "}

                                                {item.actual_production
                                                    ?.unit || "nos"}
                                            </td>

                                            <td className="bold">
                                                {item.remark || ""}
                                            </td>

                                        </tr>
                                    )
                                )}


                                {/* =================================
                                    MANPOWER / SHIFT SECTION
                                ================================= */}

                                {report.manpower?.map(
                                    (item, index) => {

                                        const shiftData =
                                            report.shift?.rows?.find(
                                                (row) =>
                                                    row.activity ===
                                                    item.activity
                                            );

                                        return (
                                            <tr
                                                key={`manpower-${index}`}
                                            >

                                                <td>
                                                    {item.activity}
                                                </td>

                                                <td className="center">
                                                    {item.machine_no ||
                                                        ""}
                                                </td>

                                                <td className="center">
                                                    {
                                                        item.man_power_required
                                                    }
                                                </td>

                                                <td className="center">
                                                    {
                                                        item.actual_utilized_man
                                                    }
                                                </td>

                                                <td className="center bold">
                                                    {
                                                        shiftData?.description ||
                                                        ""
                                                    }
                                                </td>

                                                <td className="center bold">
                                                    {
                                                        shiftData?.shift_a ??
                                                        ""
                                                    }
                                                </td>

                                                <td className="center bold">
                                                    {
                                                        shiftData?.shift_b ??
                                                        ""
                                                    }
                                                </td>

                                            </tr>
                                        );
                                    }
                                )}


                                {/* =================================
                                    SHIFT TOTAL
                                ================================= */}

                                {report.shift?.total && (
                                    <tr>

                                        <td>
                                            DEGREASING 2
                                        </td>

                                        <td></td>

                                        <td className="center">
                                            2
                                        </td>

                                        <td className="center">
                                            2
                                        </td>

                                        <td className="yellow-cell center bold">
                                            TOTAL
                                        </td>

                                        <td className="yellow-cell center bold">
                                            {
                                                report.shift.total
                                                    .shift_a
                                            }
                                        </td>

                                        <td className="yellow-cell center bold">
                                            {
                                                report.shift.total
                                                    .shift_b
                                            }
                                        </td>

                                    </tr>
                                )}


                                {/* =================================
                                    TOTAL
                                ================================= */}

                                <tr className="total-row">

                                    <td className="center bold">
                                        TOTAL
                                    </td>

                                    <td></td>

                                    <td className="center bold">
                                        0
                                    </td>

                                    <td className="center bold yellow-cell">
                                        {totalActualMan}
                                    </td>

                                    <td></td>
                                    <td></td>
                                    <td></td>

                                </tr>


                                {/* =================================
                                    VERIFICATION
                                ================================= */}

                                <tr className="empty-row">
                                    <td colSpan="7"></td>
                                </tr>

                                {report.verification?.map(
                                    (item, index) => (
                                        <React.Fragment
                                            key={`verify-${index}`}
                                        >

                                            <tr className="verified-row">

                                                <td colSpan="7">

                                                    <strong>
                                                        Verified by :{" "}
                                                        {
                                                            item.verified_by
                                                        }
                                                    </strong>

                                                </td>

                                            </tr>

                                            {index <
                                                report.verification
                                                    .length -
                                                1 && (
                                                    <tr className="empty-row">
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                )}

                                        </React.Fragment>
                                    )
                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            )}

        </div>
    );
};

export default ProductionPlanActualReport;